import React, { useEffect, useState } from "react";
import { Button, Search, Select, Table, IconDownload, IconUpload, Tabs } from "@veneer/core";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import moment from "moment";
import { currencyFormat } from "./../../../common/js/utils/numberFormat";
import XLSX from "xlsx";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import UploadModal from './UploadModal';
import { unique } from "jquery";

function PriceList (props) {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const connectApi = new ConnectAPI();
  const [tableData, setTableData] = useState([]);
  const [channelsOptions, setChannelsOptions] = useState([]);
  const [channelsOptionsSpecial, setChannelsOptionsSpecial] = useState([]);
  const [dateSelected, setDateSelected] = useState();
  const [datesView, setDatesView] = useState([]);
  const [activeTabIndex, setactiveTabIndex] = useState(0);
  const [showUploadPricingListModal, setShowUploadPricingListModal] = useState();
  const [tableDataSpecial, setTableDataSpecial] = useState([]);
  const [tableEnduser, settableEnduser]=useState([]);
  const [selectchannel,setselectchannel]=useState([]);
  const [valuechannel, setvaluechannel]=useState();
  const [outprice, setoutprice]=useState([]);
  const [filterprice,setfilterprice]=useState([]);
  function sort(array, orderBy, orderType) { 
    return array.sort((a, b) => {
      const value = (orderType === 'descending')
        ? descendingComparator(a, b, orderBy)
        : -descendingComparator(a, b, orderBy);
  
      return value;
    });
  }
  function filter(array, filters) {
    let arrayFiltered = array;
    Object.keys(filters).forEach((value) => {
      const filterValue = filters[value];
      const filter = typeof filterValue === 'object' ? filterValue[0] : filterValue;
      if (filter) {
        arrayFiltered = arrayFiltered.filter((a) => {
          const aUpper = a[value] && a[value].toString().toUpperCase();
          const filterUpper = filter && filter.toString().toUpperCase();
          return aUpper.indexOf(filterUpper) > -1;
        });
      }
    });
    return arrayFiltered;
  }
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  useEffect(() => {
    //validate location
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let validate=false;
    currentUser.urls.forEach(ur=>{
      if (ur==window.location.pathname){
        validate=true;
      }
    });
    if (validate==false){
      const { history } = props;
        history.push({
          pathname: '/' 
        });
    }
    //end validate
    const fetchData = () => {
      setIsLoading(true);
      connectApi.get("api/Channels/reports/Dates/", 
            "", 
            datesLoad
        ).catch((error) => {
          setIsLoading(false);
        Swal.fire(
          "Error " + error.response.status,
          error.response.data,
          "error"
        );
      });
    };
    const datesLoad = (status, data) => {
      const items = data.slice(0, 9).map((item) => {
        item.date = new Date(item.date).setMonth(new Date(item.date).getMonth() + 2);
        return {
          value: moment(item.date).format("YYYY-MM-DDTHH:mm:ss"),
          label: moment(item.date).format("MMM") + " " + moment(item.date).format("YYYY"),
        };
      });
      const date = items[2] === undefined ? null : items[2].value;
      setDateSelected(date);
      setDatesView(items);
    };
    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      connectApi.get("api/Channels/priceList",
        {
          params: {
            customerId:
              currentUser.idRole == 9 ||
                currentUser.idRole == 10 ||
                currentUser.idRole == 11 ||
                currentUser.idRole == 12
                ? currentUser.idCustomer
                : null, //end users and channels should only see price list for channels
            date: dateSelected
          },
        },
        dataResponseLoad
      ).catch((error) => {
        setIsLoading(false);
        Swal.fire(
          "Error " + error.response.status,
          error.response.data,
          "error"
        );
      });
    };
    const dataResponseLoad = (status, data) => {
      

      const resultado=[];
      const channels=data['report'].map(item=>item.idCustomer).filter(onlyUnique);
      channels.map((item)=>{
        let it=filter(data['report'],{
          idCustomer: item
        });
        resultado.push({value:item,label:it[0].customerName});
      });
      setselectchannel(resultado);
      if (currentUser.idCustomer!="HP"){
        setvaluechannel(currentUser.idCustomer);
        var pri=data['listwithoutPrices'].filter(item=>item.idCustomer==currentUser.idCustomer);
        setfilterprice(pri);
      }else{
        setfilterprice(data['listwithoutPrices']);
      }
      setoutprice(data['listwithoutPrices']);
      if (currentUser.idRole==11 || currentUser.idRole==12){
        data['result'].map((item, key) => {
          item.id = key;
          item.priceFormatted = item.price == null ? "-" : currencyFormat(item.price, "USD");
          item.startDate = moment(item.startDate).format("MMM/YYYY");
          item.expireDate = moment(item.expireDate).format("MMM/YYYY");
          item.dateUpdated = item.dateUpdated ? moment(item.dateUpdated).format("MMM/YYYY") : '';
          item.idUserUpdated = item.idUserUpdated ? item.idUserUpdated : '';
        });
        settableEnduser(data['result'] === undefined ? [] : data['result']);
      }
      data['reportSpecial'].map((item, key) => {
        item.id = key;
        item.priceFormatted = item.price == null ? "-" : currencyFormat(item.price, "USD");
        item.startDate = moment(item.startDate).format("MMM/YYYY");
        item.expireDate = moment(item.expireDate).format("MMM/YYYY");
        item.dateUpdated = item.dateUpdated ? moment(item.dateUpdated).format("MMM/YYYY") : '';
        item.idUserUpdated = item.idUserUpdated ? item.idUserUpdated : '';
      });
      setTableDataSpecial(data['reportSpecial'] === undefined ? [] : data['reportSpecial']);
      data['report'].map((item, key) => {
        item.id = key;
        item.priceFormatted = item.price == null ? "-" : currencyFormat(item.price, "USD");
        item.startDate = moment(item.startDate).format("MMM/YYYY");
        item.expireDate = moment(item.expireDate).format("MMM/YYYY");
        item.dateUpdated = item.dateUpdated ? moment(item.dateUpdated).format("MMM/YYYY") : '';
        item.idUserUpdated = item.idUserUpdated ? item.idUserUpdated : '';
      });
      setTableData(data['report'] === undefined ? [] : data['report']);
      const customerID = [ ...new Set(data['report'].map((item) => item.idCustomer)) ];
      const CustomerName = [ ...new Set(data['report'].map((item) => item.customerName)) ];
      let channelOptions = [];
      for (let i = 0; i < customerID.length; i++)
        channelOptions.push({ value: customerID[i], label: CustomerName[i] });
      setChannelsOptions(channelOptions);
      const customerIDSpecial = [ ...new Set(data['reportSpecial'].map((item) => item.idCustomer)) ];
      const CustomerNameSpecial = [ ...new Set(data['reportSpecial'].map((item) => item.customerName)) ];
      let channelOptionsSpecial = [];
      for (let i = 0; i < customerIDSpecial.length; i++)
        channelOptionsSpecial.push({ value: customerIDSpecial[i], label: CustomerNameSpecial[i] });
      setChannelsOptionsSpecial(channelOptionsSpecial);
      setIsLoading(false);
    };
    if (dateSelected != undefined)
      fetchData();
  }, [dateSelected]);

  function descendingComparator(a, b, orderBy) {
    const aSort =a[orderBy] && a[orderBy].toString().toUpperCase();
    const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
    if (orderBy=="series", orderBy=="units"){
      if (parseInt(bSort) < parseInt(aSort)) 
        return -1;
      if (parseInt(bSort) > parseInt(aSort))
        return 1;
    }if(orderBy=="priceFormatted"){
      var atemp = aSort.replace(/[^0-9.-]+/g,"");
      var btemp = bSort.replace(/[^0-9.-]+/g,"");
      if (parseFloat(btemp) < parseFloat(atemp)) 
        return -1;
      if (parseFloat(btemp) > parseFloat(atemp))
        return 1;
    }else if(orderBy=="startDate" || orderBy=="expireDate" || orderBy=="dateUpdated"){
        if (Date.parse(bSort) < Date.parse(aSort))
            return -1;
        if (Date.parse(bSort) > Date.parse(aSort))
            return 1;
    }else{
      if (bSort < aSort)
          return -1;
      if (bSort > aSort)
          return 1;
    }
    return 0;
  }
  function filterSort(array, filters, orderBy, orderType) {
      let arrayFiltered = array;
      Object.keys(filters).forEach((value) => {
          const filterValue = filters[value];
          const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
          if (filter)
            arrayFiltered = arrayFiltered.filter((a) => {
              const aUpper = a[value] && a[value].toString().toUpperCase();
              const filterUpper = filter && filter.toString().toUpperCase();
              return aUpper.indexOf(filterUpper) > -1;
            });
        });
      return arrayFiltered.sort((a, b) => {
          const value = (orderType === 'descending')
          ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
          return value;
      });
  }
  const selectTab = () => (index) => {
    setactiveTabIndex(index);
  };

  const RenderTabOne = () => {
    const [pnFilter, setPnFilter] = useState("");
    const [descriptionFilter, setDescriptionFilter] = useState("");
    const [pressTypeFilter, setPressTypeFilter] = useState("");
    const [channelsFilter, setChannelsFilter] = useState([]);
    const [orderBy, setOrderBy] = useState("customerName");
    const [orderType, setOrderType] = useState("ascending");
    const pageSize = 50;
    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChange = (page) => setCurrentPage(page);
    const [order, setOrder] = useState([
      "customerName",
      "idPart",
      "description",
      "priceFormatted",
      "units",
      "pressClassification",
      "series",
      "startDate",
      "expireDate",
      "idUserUpdated",
      "dateUpdated"
    ]);
    const filteredData = filterSort(
      tableData,
      {
        idPart: pnFilter,
        description: descriptionFilter,
        pressClassification: pressTypeFilter,
        idCustomer: channelsFilter,
      },
      orderBy,
      orderType
    );
    let pagedData = filteredData.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
      setOrderBy(id);
      setOrderType(type);
    };
    return (
      <div>
        <br />
        <Row>
          <Col>
            <p>
              <b>
                {t('pricelist.notes2')}
              </b>
            </p>
          </Col>
          <Col style={{ display: currentUser.idRole == 10 || currentUser.idRole == 9 ? 'flex' : 'none', flexDirection: 'row-reverse' }}>
            <Button
              leadingIcon={<IconUpload />}
              style={{ alignSelf: 'center' }}
              onClick={() => setShowUploadPricingListModal(true)}
              loading={isLoading}
            >
              {t('uploadPriceList')}
            </Button>
          </Col>
        </Row>
        <div>
          <br />
          <div
            style={{
              backgroundColor: "#f2f2f2",
              padding: "0.5%",
            }}
          >
            <div
              style={{
              width: '120px',
              position: "absolute",
              background: "white",
              marginTop: "5px",
              }}
            >
            <Select
                name="datesSearsh"
                onChange={(val) => {
                  setDateSelected(val.value);
                  setCurrentPage(1);
                }}
                options={datesView}
                placeholder= {t('date')}
                value={[dateSelected]}
                clearIcon={false}
              />
            </div>
            <Table
              columns={[
                {
                  id: "idPart",
                  label: "PN",
                  filter: (
                    <Search
                      id="idPart-search"
                      value={pnFilter}
                      onChange={(val) => {
                        setPnFilter(val);
                        setCurrentPage(1);
                      }}
                    />
                  ),
                },
                {
                  id: "description",
                  label: t('Description'),
                  filter: (
                    <Search
                      id="description-search"
                      value={descriptionFilter}
                      onChange={(val) => {
                        setDescriptionFilter(val);
                        setCurrentPage(1);
                      }}
                    />
                  ),
                },
                {
                  id: "priceFormatted",
                  label: t('pricelist.table.price'),
                },
                {
                  id: "units",
                  label: t('pricelist.table.units'),
                },
                {
                  id: "pressClassification",
                  label: t('pricelist.table.presstype'),
                  filter: (
                    <Search
                      id="pressClassification-search"
                      value={pressTypeFilter}
                      onChange={(val) => {
                        setPressTypeFilter(val);
                        setCurrentPage(1);
                      }}
                    />
                  ),
                },
                {
                  id: "series",
                  label: t('series'),
                },
                {
                  id: "customerName",
                  label: t('channel'),
                  filter: (
                    <Select
                      id="customer-select-filter"
                      options={channelsOptions}
                      value={channelsFilter}
                      onClear={() => setChannelsFilter([])}
                      onChange={({ value }) => {
                        setChannelsFilter([value]);
                        setCurrentPage(1);
                      }}
                      placeholder={t("channel")}
                      disabled={false}
                    />
                  ),
                },
                {
                  id: "startDate",
                  label: t('specialcondition.startdate'),
                },
                {
                  id: "expireDate",
                  label: t('expiredate'),
                },
                {
                  id: 'idUserUpdated',
                  label: t('pricelist.table.idUserUpdated'),
                },
                {
                  id: 'dateUpdated',
                  label: t('pricelist.table.dateUpdated'),
                }
              ]}
              showFilters
              columnReorder
              data={pagedData}
              loading={isLoading}
              onSort={handleSort}
              onColumnReorder={(reOrder) => setOrder(reOrder)}
              preferences={{
                width: [
                  {
                      columnId: 'series', width: 50
                  },
                ],
                defaultOrder: order,
                sortBy: {
                  id: orderBy,
                  type: orderType,
                },
                order: order
              }}
              pagination={{
                currentPage,
                onPageChange: handlePageChange,
                pageSize,
                totalItems: filteredData.length,
              }}
            ></Table>
            <div style={{ textAlign: "left" }}>
              <Button
                onClick={()=>{
                  setTimeout(() => {
                    const dataXlsx = filteredData.map((item) => { return item; });
                    const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                    const wb = XLSX.utils.book_new();
                    const date = moment(new Date()).format('YYYYMMDDHHmm');
                    const filename = 'PriceListGeneral-' + date + '.xlsx';
                    const ws_name = "PriceListGeneral";
                    XLSX.utils.book_append_sheet(wb, ws, ws_name);
                    XLSX.writeFile(wb, filename);
                  }, 750);
                }}
                disabled={filteredData.length === 0}
                leadingIcon={<IconDownload />}
                title={t('download data')}
              >
                {t('download')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );

  };
  const RenderTabTwo = () => {
    const [idPartFilter, setIdPartFilter] = useState("");
    const [idPressFilter, setIdPressFilter] = useState("");
    const [userNameFilter, setUserNameFilter] = useState("");
    const [classificationFilter, setClassificationFilter] = useState("");
    const [customerNameFilter, setCustomerNameFilter] = useState("");
    const [orderBySpecial, setOrderBySpecial] = useState("customerName");
    const [orderTypeSpecial, setOrderTypeSpecial] = useState("ascending");
    const pageSize = 50;
    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChangeSpecial = (page) => setCurrentPage(page);
    const [orderSpecial, setOrderSpecial] = useState([
      "customerName",
      "userName",
      "idPress",
      "idPart",
      "priceFormatted",
      "units",
      "classification",
      "series",
      "startDate",
      "expireDate",
      "idUserUpdated",
      "dateUpdated"
    ]);
    const filteredDataSpecial = filterSort(
      tableDataSpecial,
      {
        idPart: idPartFilter,
        idPress: idPressFilter,
        userName: userNameFilter,
        classification: classificationFilter,
        idCustomer: customerNameFilter,
      },
      orderBySpecial,
      orderTypeSpecial
    );
    let pagedDataspecial = filteredDataSpecial.slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
    const handleSortSpecial = (_, { id, type }) => {
      setOrderBySpecial(id);
      setOrderTypeSpecial(type);
    };
    return (
      <div>
          <br />
          <Row>
            <Col>
              <p>
                <b>
                  {t('pricelist.notes2')}
                </b>
              </p>
            </Col>
            <Col style={{ display: currentUser.idRole == 10 || currentUser.idRole == 9 ? 'flex' : 'none', flexDirection: 'row-reverse' }}>
              <Button
                leadingIcon={<IconUpload />}
                style={{ alignSelf: 'center' }}
                onClick={() => setShowUploadPricingListModal(true)}
                loading={isLoading}
              >
                {t('uploadPriceList')}
              </Button>
            </Col>
          </Row>
          <div>
            <br />
            <div
              style={{
                backgroundColor: "#f2f2f2",
                padding: "0.5%",
              }}
            >
              <div
                style={{
                width: '120px',
                position: "absolute",
                background: "white",
                marginTop: "5px",
                }}
              >
              <Select
                  name="datesSearsh"
                  onChange={(val) => {
                    setDateSelected(val.value);
                    setCurrentPage(1);
                  }}
                  options={datesView}
                  placeholder= {t('date')}
                  value={[dateSelected]}
                  clearIcon={false}
                />
              </div>
              <Table
                showFilters
                columnReorder
                columns={[
                  {
                    id: "customerName",
                    label: t('channel'),
                    filter: (
                      <Select
                        id="customerName-search"
                        options={channelsOptionsSpecial}
                        value={customerNameFilter}
                        onClear={() => setCustomerNameFilter([])}
                        onChange={({ value }) => {
                          setCustomerNameFilter([value]);
                          setCurrentPage(1);
                        }}
                        placeholder={t("channel")}
                        disabled={false}
                      />
                    ),
                  },
                  {
                    id: 'userName',
                    label: t('endUserId'),
                    filter: (
                      <Search
                        id="userName-search"
                        value={userNameFilter}
                        onChange={(val) => {
                          setUserNameFilter(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "idPress",
                    label: t('press id'),
                    filter: (
                      <Search
                        id="userName-search"
                        value={idPressFilter}
                        onChange={(val) => {
                          setIdPressFilter(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "idPart",
                    label: t('pricelist.table.idPart'),
                    filter: (
                      <Search
                        id="idPart-search"
                        value={idPartFilter}
                        onChange={(val) => {
                          setIdPartFilter(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "priceFormatted",
                    label: t('pricelist.table.price'),
                  },
                  {
                    id: "units",
                    label: t('pricelist.table.units'),
                  },
                  {
                    id: "classification",
                    label: t('classification'),
                    filter: (
                      <Search
                        id="classification-search"
                        value={classificationFilter}
                        onChange={(val) => {
                          setClassificationFilter(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "series",
                    label: t('series'),
                  },
                  {
                    id: "startDate",
                    label: t('specialcondition.startdate'),
                  },
                  {
                    id: "expireDate",
                    label: t('expiredate'),
                  },
                  {
                    id: 'idUserUpdated',
                    label: t('pricelist.table.idUserUpdated'),
                  },
                  {
                    id: 'dateUpdated',
                    label: t('pricelist.table.dateUpdated'),
                  }
                ]}
                data={pagedDataspecial}
                onSort={handleSortSpecial}
                loading={isLoading}
                onColumnReorder={(newOrder) => setOrderSpecial(newOrder)}
                preferences={{
                  width: [
                    {
                        columnId: 'series', width: 50
                    },
                  ],
                  defaultOrder: orderSpecial,
                  order: orderSpecial,
                  sortBy: {
                    id: orderBySpecial,
                    type: orderTypeSpecial,
                  },
                }}
                pagination={{
                  currentPage,
                  onPageChange: handlePageChangeSpecial,
                  pageSize,
                  totalItems: filteredDataSpecial.length,
                }}
              ></Table>
              <div style={{ textAlign: "left" }}>
                <Button
                  onClick={()=>{
                    setTimeout(() => {
                      const dataXlsx = filteredDataSpecial.map((item) => { return item; });
                      const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: orderSpecial });
                      const wb = XLSX.utils.book_new();
                      const date = moment(new Date()).format('YYYYMMDDHHmm');
                      const filename = 'PriceListSpecial-' + date + '.xlsx';
                      const ws_name = "PriceListSpecial";
                      XLSX.utils.book_append_sheet(wb, ws, ws_name);
                      XLSX.writeFile(wb, filename);
                    }, 750);
                  }}
                  disabled={filteredDataSpecial.length === 0}
                  leadingIcon={<IconDownload />}
                  title={t('download data')}
                >
                  {t('download')}
                </Button>
              </div>
            </div>
          </div>
          <br />
          {currentUser.idRole == 9 || currentUser.idRole == 10 ? (
            <UploadModal
              showUploadPricingListModal={showUploadPricingListModal}
              setShowUploadPricingListModal={setShowUploadPricingListModal}
              fetchData={useEffect}
            />
          ) : undefined}
        </div>
    );
    
  };
  
  const RenderTabThree = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChange = (page) => setCurrentPage(page);

    const ConfigColumns = [
      {
        id: "customerName",
        label: t('channel'),
      },
      {
        id: 'userName',
        label: t('endUserId'),
      },
      {
        id: "idPress",
        label: t('press id'),
      },
      {
        id: "idPart",
        label: t('pricelist.table.idPart'),
      },
      {
        id: "priceFormatted",
        label: t('pricelist.table.price'),
      },
      {
        id: "units",
        label: t('pricelist.table.units'),
      },
      {
        id: "classification",
        label: t('classification'),
      },
      {
        id: "series",
        label: t('series'),
      },
      {
        id: "startDate",
        label: t('specialcondition.startdate'),
      },
      {
        id: "expireDate",
        label: t('expiredate'),
      },
      {
        id: 'idUserUpdated',
        label: t('pricelist.table.idUserUpdated'),
      },
      {
        id: 'dateUpdated',
        label: t('pricelist.table.dateUpdated'),
      }
    ];
    const [pageSize, setPageSize] = useState(50);
    const [idPartFilter, setIdPartFilter] = useState('');
    const [idPressFilter, setIdPressFilter]=useState('');
    const [userNameFilter, setUserNameFilter]=useState('');
    const [classificationFilter, setClassificationFilter]=useState('');
    const [customerNameFilter, setCustomerNameFilter]=useState('');
    const [orderBy, setOrderBy] = useState('customerName');
    const [orderType, setOrderType] = useState('ascending');
    const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
    const [orderActive, setOrderActive] = useState(
      ConfigColumns.map((c) => c.id)
    );
    const handleOnColumnReorder = (newOrder) => {
        setOrderActive(newOrder);
        setOrder(newOrder);
    };

    let filteredData=filter(tableEnduser,
      {
        idPart: idPartFilter,
        idPress: idPressFilter,
        userName: userNameFilter,
        classification: classificationFilter,
        idCustomer: customerNameFilter,
      }
    );
    let pagdata=sort(filteredData, orderBy, orderType).slice(
      (currentPage - 1) * pageSize,
      (currentPage - 1) * pageSize + pageSize
    );
    const handleSort = (_, { id, type }) => {
        setOrderBy(id);
        setOrderType(type);
    };
    const [orderSpecial, setOrderSpecial] = useState([
      "customerName",
      "userName",
      "idPress",
      "idPart",
      "priceFormatted",
      "units",
      "classification",
      "series",
      "startDate",
      "expireDate",
      "idUserUpdated",
      "dateUpdated"
    ]);
    return (
      <div>
          <br />
          <Row>
            <Col>
              <p>
                <b>
                  {t('pricelist.notes2')}
                </b>
              </p>
            </Col>
            <Col style={{ display: currentUser.idRole == 10 || currentUser.idRole == 9 ? 'flex' : 'none', flexDirection: 'row-reverse' }}>
              <Button
                leadingIcon={<IconUpload />}
                style={{ alignSelf: 'center' }}
                onClick={() => setShowUploadPricingListModal(true)}
                loading={isLoading}
              >
                {t('uploadPriceList')}
              </Button>
            </Col>
          </Row>
          <div>
            <br />
            <div
              style={{
                backgroundColor: "#f2f2f2",
                padding: "0.5%",
              }}
            >
              <div
                style={{
                width: '120px',
                position: "absolute",
                background: "white",
                marginTop: "5px",
                }}
              >
              <Select
                  name="datesSearsh"
                  onChange={(val) => {
                    setDateSelected(val.value);
                    setCurrentPage(1);
                  }}
                  options={datesView}
                  placeholder= {t('date')}
                  value={[dateSelected]}
                  clearIcon={false}
                />
              </div>
              <Table
                showFilters
                columnReorder
                columns={[
                  {
                    id: "customerName",
                    label: t('channel'),
                    filter: (
                      <Select
                        id="customerName-search"
                        options={channelsOptionsSpecial}
                        value={customerNameFilter}
                        onClear={() => setCustomerNameFilter([])}
                        onChange={({ value }) => {
                          setCustomerNameFilter([value]);
                          setCurrentPage(1);
                        }}
                        placeholder={t("channel")}
                        disabled={false}
                      />
                    ),
                  },
                  {
                    id: 'userName',
                    label: t('endUserId'),
                    filter: (
                      <Search
                        id="userName-search"
                        value={userNameFilter}
                        onChange={(val) => {
                          setUserNameFilter(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "idPress",
                    label: t('press id'),
                    filter: (
                      <Search
                        id="userName-search"
                        value={idPressFilter}
                        onChange={(val) => {
                          setIdPressFilter(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "idPart",
                    label: t('pricelist.table.idPart'),
                    filter: (
                      <Search
                        id="idPart-search"
                        value={idPartFilter}
                        onChange={(val) => {
                          setIdPartFilter(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "priceFormatted",
                    label: t('pricelist.table.price'),
                  },
                  {
                    id: "units",
                    label: t('pricelist.table.units'),
                  },
                  {
                    id: "classification",
                    label: t('classification'),
                    filter: (
                      <Search
                        id="classification-search"
                        value={classificationFilter}
                        onChange={(val) => {
                          setClassificationFilter(val);
                          setCurrentPage(1);
                        }}
                      />
                    ),
                  },
                  {
                    id: "series",
                    label: t('series'),
                  },
                  {
                    id: "startDate",
                    label: t('specialcondition.startdate'),
                  },
                  {
                    id: "expireDate",
                    label: t('expiredate'),
                  },
                  {
                    id: 'idUserUpdated',
                    label: t('pricelist.table.idUserUpdated'),
                  },
                  {
                    id: 'dateUpdated',
                    label: t('pricelist.table.dateUpdated'),
                  }
                ]}
                data={pagdata}
                onSort={handleSort}
                loading={isLoading}
                onColumnReorder={handleOnColumnReorder}
                /*onColumnReorder={(newOrder) => setOrderSpecial(newOrder)}
                preferences={{
                  width: [
                    {
                        columnId: 'series', width: 50
                    },
                  ],
                  defaultOrder: [
                    "customerName",
                    "userName",
                    "idPress",
                    "idPart",
                    "priceFormatted",
                    "classification",
                    "series",
                    "startDate",
                    "expireDate",
                    "idUserUpdated",
                    "dateUpdated"
                  ],
                  order: orderSpecial,
                  sortBy: {
                    id: orderBySpecial,
                    type: orderTypeSpecial,
                  },
                }}
                */
                preferences={{
                  defaultOrder: ConfigColumns.map((c) => c.customerName),
                  order,
                  sortBy: {
                    id: orderBy,
                    type: orderType,
                  },
                  
                  width: [
                    {
                      columnId: 'series', width: 50
                    },
                   
                  ]
                }}
                pagination={{
                  currentPage,
                  onPageChange: handlePageChange,
                  pageSize,
                  totalItems: filteredData.length,
                }}
                /*pagination={{
                  currentPage,
                  onPageChange: handlePageChangeSpecial,
                  pageSize,
                  totalItems: filteredDataSpecial.length,
                }}*/

              ></Table>
              <div style={{ textAlign: "left" }}>
                <Button
                  onClick={()=>{
                    setTimeout(() => {
                      filteredData.map((item) => { return delete(item['idCustomer'])});
                      filteredData.map((item) => { return delete(item['id'])});
                      const dataXlsx = filteredData.map((item) => { return item; });
                      const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: orderSpecial });
                      const wb = XLSX.utils.book_new();
                      const date = moment(new Date()).format('YYYYMMDDHHmm');
                      const filename = 'PriceListGeneral-' + date + '.xlsx';
                      const ws_name = "PriceListGeneral";
                      XLSX.utils.book_append_sheet(wb, ws, ws_name);
                      XLSX.writeFile(wb, filename);
                    }, 750);
                  }}
                  disabled={filteredData.length === 0}
                  leadingIcon={<IconDownload />}
                  title={t('download data')}
                >
                  {t('download')}
                </Button>
              </div>
            </div>
          </div>
          <br />
          {currentUser.idRole == 9 || currentUser.idRole == 10 ? (
            <UploadModal
              showUploadPricingListModal={showUploadPricingListModal}
              setShowUploadPricingListModal={setShowUploadPricingListModal}
              fetchData={useEffect}
            />
          ) : undefined}
        </div>
    );
    
  };
  const onClear = () => {
    setvaluechannel();
    if (currentUser.idCustomer!="HP"){
      var pri=outprice.filter(item=>item.idCustomer==currentUser.idCustomer);
      setfilterprice(pri);
    }else{
      setfilterprice(outprice);
    }
  };
  const WithoutPrices=()=>{
    const [orderBy, setOrderBy] = useState("Enduser");
    const [orderType, setOrderType] = useState("ascending");
    const [order, setOrder] = useState([
      'customer',
      'enduser',
      'idpress',
      'idPart',
      'description'
  ]);
    return(<>
        <div>
            <br />
            <div
              style={{
                backgroundColor: "#f2f2f2",
                padding: "0.5%",
              }}
            >
              <div
                style={{
                width: '300px',
                position: "absolute",
                background: "white",
                marginTop: "5px",
                }}
              >
                <Select
                  name="Channelselect"
                  onChange={(val) => {
                    setvaluechannel(val.value);
                    var show=outprice.filter(item=>item.idCustomer==val.value);
                    setfilterprice(show);
                  }}
                  options={selectchannel}
                  placeholder= {t('select_channel')}
                  value={[valuechannel]}
                  clearIcon={true}
                  onClear={onClear}
                />
              </div>
              <Table
                showFilters
                columnReorder
                columns={[
                  {
                    id: "customer",
                    label: t('channel'),
                   
                  },
                  {
                    id: 'enduser',
                    label: t('endUser'),
                  },
                  {
                    id: "idpress",
                    label: t('press id'),
                  
                  },
                  {
                    id: "idPart",
                    label: t('pricelist.table.idPart'),
                  },
                  {
                    id: "description",
                    label: "description",
                  }
                 
                ]}
                data={filterprice}
                loading={isLoading}
                preferences={{
                  defaultOrder: "Enduser",
                  sortBy: {
                    id: orderBy,
                    type: orderType,
                  },
                  
                  width: [
                    {
                      columnId: 'series', width: 50
                    },
                   
                  ]
                }}
              ></Table>  
              <div style={{ textAlign: "left" }}>
              <Button
                            onClick={()=>{
                                setTimeout(() => {
                                const dataXlsx = filterprice.map((item) => { return item; });
                                const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: order });
                                const wb = XLSX.utils.book_new();
                                const date = moment(new Date()).format('YYYYMMDDHHmm');
                                const filename = 'WithoutPrices-' + date + '.xlsx';
                                const ws_name = "WithoutPrices";
                                XLSX.utils.book_append_sheet(wb, ws, ws_name);
                                XLSX.writeFile(wb, filename);
                                }, 750);
                            }}
                            disabled={filterprice.length === 0}
                            leadingIcon={<IconDownload />}
                            title={t('download data')}
                        >
                {t('download')}
              </Button>
            </div>
            </div>
          </div>
    </>);
  }
  let list=[];
  if (currentUser.idRole==11 || currentUser.idRole==12 ){
    list.push({id:0, label:t('PriceList'), content:<div><RenderTabThree/></div>});
  }else{
    list.push({ id: 0, label: t('pricelist.notes0'), content: <div><RenderTabOne /></div>},
    { id: 1, label: t('pricelist.notes1'), content: <div><RenderTabTwo /></div>},
    {id:2, label:"Supplies without prices", content:<div><WithoutPrices/></div>});
  }

  /*let list = [
    { id: 0, label: t('pricelist.notes0'), content: <div><RenderTabOne /></div>},
    { id: 1, label: t('pricelist.notes1'), content: <div><RenderTabTwo /></div>}
  ];*/

  return (<>
    <Tabs
      controlId="default"
      onChangeTab={selectTab()}
      selectedTabId={activeTabIndex}
      tabs={list}
    />
  </>
  );
};

export default PriceList;
